import { afterRenderEffect, ChangeDetectionStrategy, Component, inject, signal, DOCUMENT } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MetaService } from '../../meta.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'terms-campaign',
  templateUrl: './terms-campaign.component.html',
  styleUrls: ['./info.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionModule, RouterLink, MatIconModule, MatButtonModule]
})
export default class TermsCampaignComponent {
  fragment = signal<string>('');
  activated = inject(ActivatedRoute);
  meta = inject(MetaService);
  document = inject(DOCUMENT);

  constructor() {
    this.activated.fragment.pipe(takeUntilDestroyed()).subscribe(fragment => {
      this.fragment.set(fragment??'');
    });
    this.meta.setTags('cloudigo Malta - Terms & Conditions');

    afterRenderEffect(() => {
      const fragment = this.fragment();
      this.onExpand(fragment);
    });
  }

  onExpand(id: string){
    this.fragment.set(id);
    setTimeout(() => {
      let element = this.document.getElementById(id);
      if (element) {
        element.scrollIntoView({behavior: 'smooth' });
      }
    }, 500);
  }
}
